import React from "react"
import CoreTransaction from "components/CoreTransaction"

const TransactionsReviewScene = (): JSX.Element => {
  return <CoreTransaction />
}

export default TransactionsReviewScene
